<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div class="view-week">
  @for (day of weekDays; track day.date; let i = $index) {
    <div class="day">
      <infl-calendar-view-day
        #view
        [hourDivCount]="options().day.hoursSection"
        [sectionHeight]="options().day.sectionHeight"
        [start]="options().day.start"
        [reduce]="reduce()"
        [day]="day.date"
        [end]="options().day.end"
        [tasks]="day.tasks"
        [dragByOutside]="dragByOutside()"
        [onDrag]="!!draggingTask"
        [canDrag]="canDrag()"
        [canResize]="canResize()"
        [canSelect]="canSelect()"
        [resource]="resource()"
        [teleworks]="teleworks()"
        (dragTask)="onDragTask($event)"
        (dropOutside)="onDayDropOutside(day, $event)"
        (hourSelection)="onHoursSelection(view, $event)"
        (hourPreselection)="periodPreselection.emit($event)"
        (taskHover)="taskHover.emit($event)"
        (clickOnSelection)="onClickOnSelection(view, $event)"
        (dblClickOnSelection)="onClickOnSelection(view, $event, true)"
        (taskContextMenu)="taskContextMenu.emit($event)"
        (taskUpdate)="taskUpdate.emit($event)"
        (taskDblClick)="taskDblClick.emit($event)"
        (taskCreation)="taskCreation.emit($event)"
        (taskClick)="taskClick.emit($event)"
      >
      </infl-calendar-view-day>
    </div>
  }
</div>
